import React from "react";
import { Typography } from "@material-ui/core";
import { useTranslation } from "@/langs/useTranslation";
import { useSearchParams } from "@/helpers/useSearchParams";
import { BreadCrumbs } from "@/components/device/BreadCrumbs";
import useStyles from "@/styles/groupsStyle";

import NamingList from "./NamingList";

const DeviceNaming = () => {
  const { t } = useTranslation();
  const classes = useStyles();

  return (
    <>
      <BreadCrumbs
        noTranslate
        pageName={t({ defaultMessage: "设备命名规则" })}
      />
      <div className={classes.titleWithSelect}>
        <Typography variant="h4">
          {t({ defaultMessage: "设备命名规则" })}
        </Typography>
      </div>
      <div className={classes.paperWrapper}>
        <NamingList />
      </div>
    </>
  );
};

export default DeviceNaming;
